import {
  Card,
  CardBody,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
} from "reactstrap";
import { useEffect, useState, useContext } from "react";
import { NavLink, useLocation, useHistory } from "react-router-dom";
import Moment from "moment";
import "moment-timezone";
import LoadingOverlay from "react-loading-overlay";
import { MainContext } from "context/MainContext.js";
LoadingOverlay.propTypes = undefined;

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";

function ConfigurationContent() {
  const location = useLocation();
  const [content, setContent] = useState([]);
  const [creationDate, setCreationDate] = useState();
  const [settings, setSettings] = useState([]);

  const [showLoading, setShowLoading] = useState(false);

  const history = useHistory();
  const privileges = useContext(MainContext);

  useEffect(() => {
    if (
      !Utilities.hasAccess(privileges["devices.configurations.content.display"])
    ) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }
  }, []);

  useEffect(() => {
    setShowLoading(true);
    fetch("/api/v1/device/configuration/content", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
        id: location.state.id,
        mode: "manual",
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        setCreationDate(actualData.data.creationDate);
        setContent(actualData.data.content);
        setSettings(actualData.settings);
      })
      .catch((err) => {
        setShowLoading(false);
        console.log(err.message);
      });
  }, []);

  return (
    <div className="content">
      <LoadingOverlay
        active={showLoading}
        spinner
        text="Loading data"
        className={showLoading ? "loading" : ""}
      />
      <Row>
        <Col md="12">
          <Card>
            <CardBody>
              <Breadcrumb>
                <BreadcrumbItem>
                  <NavLink
                    to={{
                      pathname: "/admin/dashboard",
                    }}
                  >
                    <FontAwesomeIcon icon={faHome} />
                  </NavLink>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <NavLink
                    to={{
                      pathname: "/admin/devices/list",
                    }}
                  >
                    GAM
                  </NavLink>
                  <i>&lt;{location.state.serialNumber}&gt;</i>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <NavLink
                    to={{
                      pathname: "/admin/configurations/list",
                      state: {
                        serialNumber: location.state.serialNumber,
                      },
                    }}
                  >
                    Configurations
                  </NavLink>{" "}
                  <i>
                    &lt;
                    {settings.general_convert_date_with_user_timezone === "true"
                      ? Moment(creationDate)
                          .tz(settings.user_timezone)
                          .format("yy-MM-DD hh:mm:ss a")
                      : Moment.utc(creationDate).format("yy-MM-DD hh:mm:ss a")}
                    &gt;
                  </i>
                </BreadcrumbItem>
                <BreadcrumbItem>Content</BreadcrumbItem>
              </Breadcrumb>
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <pre>{content}</pre>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default ConfigurationContent;
